import { FC } from "react";

interface ClosingCrossLightGreyProps {
    className?: string;
    onClick?: () => void;
}

const ClosingCrossLightGrey: FC<ClosingCrossLightGreyProps> = (props) => {
    return (
        <svg
            className={props.className}
            onClick={props.onClick}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="16" height="16" rx="8" fill="#7A7A7E" />
            <path d="M5 5L11 11" stroke="#4B4B52" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11 5L5 11" stroke="#4B4B52" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default ClosingCrossLightGrey;
